import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {string?} State */
const initialState = null;

const clearState = () => null;

const haveError = (_, { payload }) => payload;

export default createReducer(initialState, {
  [types.FETCH_PREDEFINED_MESSAGE]: clearState,
  [types.FETCH_PREDEFINED_MESSAGE_FAILURE]: haveError,
  [types.APPLICATION_READY_FAILURE]: haveError,
});
